import { getRandomInt } from '@/utilities';
import Task from '@/models/Task';
import Feature from '@/models/Task/Feature';

export default class Spec extends Task {
  constructor({ product, parentTask }) {
    super({ product, parentTask });
    this.remainingTime = this.getBaseTime();
  }

  // eslint-disable-next-line class-methods-use-this
  getBaseTime() {
    return getRandomInt(1, 5);
  }

  generateSubTasks() {
    return super.generateTasks({
      TypeClass: Feature,
      product: this.product,
      count: getRandomInt(1, 10),
      hasSpec: true,
    });
  }
}
